import { defineStore } from "pinia";
import { useForm } from "@/form";

export const useStore = defineStore("user", {
    state: () => {
        return {
            userData: undefined,
        };
    },

    getters: {
        user: (state) => {
            return state.userData;
        },
        subscription: (state) => {
            return state.userData?.subscription;
        },
    },

    actions: {
        setUser(data) {
            this.userData = data;
        },

        async fetchUser() {
            try {
                const response = await useForm().post("auth_user");
                this.userData = response;
            } catch (error) {
                return error;
            }
        },

        async refresh() {
            await this.fetchUser();
        },
    },
});
